import Backdrop, { BackdropProps } from '@mui/material/Backdrop';
import React from 'react';
import { useAndroidAppRefreshGate } from '../../../commonUtils/useAndroidAppRefreshGate';

// Default backdrop for Modal and Dialog. It mounts only while the overlay is
// open, so every dialog, modal, menu, select, and popover disables the native
// Android pull-to-refresh from its own open state. The native side
// reference-counts these calls.
export const AndroidRefreshBackdrop = React.forwardRef<unknown, BackdropProps>(
  function AndroidRefreshBackdrop(props, ref) {
    // Dialog passes `as` so its styled backdrop can render this component.
    // Leaving it on the props would make Backdrop render this component again.
    const { as: _as, ...backdropProps } = props as BackdropProps & {
      as?: unknown;
    };
    useAndroidAppRefreshGate(backdropProps.open !== false);

    return (
      <Backdrop
        {...backdropProps}
        ref={ref as React.Ref<HTMLDivElement>}
        style={{ zIndex: -1, ...backdropProps.style }}
      />
    );
  }
);
